import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from '@auth/auth.component';
import { LoginComponent } from '@auth/login/login.component';
import { RecoverComponent } from '@auth/recover/recover.component';
import { ResetPasswordComponent } from '@auth/reset-password/reset-password.component';
import { Error404Component } from '@error404';
import { ServerDownComponent } from '@base/server-down/server-down.component';
import { AuthResolver } from '@auth/auth.resolver';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    resolve: {data: AuthResolver},
  },
  {
    path: 'recover',
    component: RecoverComponent
  },
  {
    path: 'reset_password/:token',
    component: ResetPasswordComponent
  },
  {
    path: 'activate_user/:token',
    component: ResetPasswordComponent
  },
  {
    path: 'connectionerror',
    component: ServerDownComponent
  },
  // {
  //   path: 'error404',
  //   component: Error404Component,
  // },
  {
    path: '**',
    // redirectTo: 'eror404',
    component: Error404Component,
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
